// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-bar[data-v-5a4a9f32] {\r\n  width: 100%;\r\n  height: 8rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
